<div class="tenant-details-container">
    <div class="flex flex-row justify-between pb-10">
        <div class="flex flex-col">
          <div class="mat-headline-5 mb-8 fw-700">{{ title }}</div>
          <div class="mat-body fw-500 fs-16">{{tenantData?.tenantId}}</div>
      </div>
      <mat-icon svgIcon="close" class="close-icon" (click)="closeSidenav()"></mat-icon>
    </div>
    <mat-divider class="mb-20 neutral-2"></mat-divider>
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="{{'TENANT_DETAILS.DETAILS' | transloco}}">
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.REALM_NAME' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.tenantId}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.IT_TICKETNUMBER' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.ticketNumber ? tenantData?.ticketNumber:'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.CUSTOMER_STATUS' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.status ? tenantData?.status:'--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.TENANT_OWNER' | transloco}}</div>
            <div class="overview-values fw-700 status-color">{{tenantData?.tenantOwner ? tenantData?.tenantOwner:'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider> 
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_DETAILS.ADMIN_CONSOLE' | transloco}}</div>
            <div class="flex overview-values fw-700"
              (click)="openUrl()">
              <mat-icon svgIcon="open_in_new" class="icon-sm mr-8 mt-4"></mat-icon>
              <span>{{'TENANT_DETAILS.ADMIN_CON' | transloco}}</span>
            </div>
          </div>
          <div>
            <div>{{'TENANT_DETAILS.MANAGEMENT_TYPE' | transloco}}</div>
            <div class="overview-values fw-700 status-color">{{tenantData?.managementType ? tenantData?.managementType:'--'}}</div>
          </div>
        </div> 
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_DETAILS.CREATED_DATE' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.dateCreated ? dateTimeFormatService.getUtcFromat(tenantData.dateCreated) : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_DETAILS.UPDATED_DATE' | transloco}}</div>
            <div class="overview-values fw-700 status-color">{{tenantData?.dateUpdated ? dateTimeFormatService.getUtcFromat(tenantData.dateUpdated) : '--'}}</div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{'ADD_TENANT.CLOUD_REGION' | transloco }}">
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_DETAILS.REGION' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.regionPair || tenantData?.temenosRegion ? tenantData?.regionPair || tenantData?.temenosRegion :'--' }}</div>
          </div>
          <div>
            <div>{{'TENANT_DETAILS.CLOUD' | transloco}}</div>
            <div class="overview-values fw-700">{{(tenantData?.cloudProvider || tenantData?.targetCloud) ? (tenantData?.cloudProvider || tenantData?.targetCloud) :'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_LIST.PRIMARY_REGION' | transloco}}</div>
            <div class="overview-values fw-700">{{(tenantData?.primaryCloudRegion || tenantData?.primaryRegion) ? (tenantData?.primaryCloudRegion || tenantData?.primaryRegion) : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_LIST.SECONDARY_REGION' | transloco}}</div>
            <div class="overview-values fw-700">{{(tenantData?.secondaryCloudRegion || tenantData?.secondaryRegion) ? (tenantData?.secondaryCloudRegion || tenantData?.secondaryRegion) : '--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
          <div class="flex flex-col min-w-[50%]">
          <div class="metrics pt-8 pb-8">
            <div class="mb-2">{{ 'TENANT_FORM.SECONDARY_DEPLOYMENT' | transloco | titlecase }}</div>
            <div class="max-w-2xl w-fit flex flex-wrap gap-1 items-center pt-8">
                <span class="overview-values fw-700">
                  {{ tenantData?.parameters?.hasSecondaryRegion }}
                </span>
            </div>
          </div> 
        </div>
      </mat-tab>
      <mat-tab label="{{'ADD_TENANT.CUSTOMER_INFORMATION' | transloco }}">
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.CUSTOMER_NAME' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.customerName ? tenantData?.customerName : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.CUSTOMER_NUMBER' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.customerNumber ? tenantData?.customerNumber:'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.CUSTOMER_REGION' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.customerRegion ? tenantData.customerRegion : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.COUNTRY' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.customerCountry ? tenantData?.customerCountry:'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.MNEMONIC' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.customerMnemonic ? tenantData.customerMnemonic : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.CUSTOMER_SCORECARD' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.scoreCard ? tenantData?.scoreCard:'--'}}</div>
          </div>
        </div>
        <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
        <div class="flex flex-row">
          <div class="metrics pt-8 pb-8">
            <div>{{'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.salesChannel ? tenantData.salesChannel : '--'}}</div>
          </div>
          <div>
            <div>{{'TENANT_FORM.CONTRACT_END_DATE' | transloco}}</div>
            <div class="overview-values fw-700">{{tenantData?.contractEndDate ? dateTimeFormatService.getUtcFromat(tenantData?.contractEndDate):'--'}}</div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{'ADD_TENANT.FEATURES' | transloco }}">
        <div class="flex flex-col pt-8 pb-8">
          <div class="flex flex-row">
            <div class="flex flex-col feature-field">{{'ADD_TENANT.FEATURES' | transloco}}</div>
            <div class="flex flex-col ml-12 value-field">{{'TENANT_LIST.NON_PII' | transloco}}</div>
            <div class="flex flex-col ml-12 value-field">{{'TENANT_LIST.PII' | transloco}}</div>
            <div class="flex flex-col ml-12 value-field">{{'TENANT_LIST.PROD' | transloco | uppercase}}</div>     
          </div>
          <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
          <ng-container *ngFor="let feature of featureList; let last = last" class="flex flex-row pt-8 pb-14">
            <div class="flex flex-row">
              <div class="flex flex-col overview-values fw-700 feature-field">{{ feature.displayName }}</div>             
              <div *ngIf="getZoneModifiable(feature,'nonpii') && feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                <mat-icon  [svgIcon]="getZoneValue(feature,'nonpii') ?'done' :'close'" [ngClass]="getZoneValue(feature,'nonpii') ? 'selected' :'not-selected'"></mat-icon>
              </div>
              <div *ngIf="!getZoneModifiable(feature,'nonpii') || !feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                <span>-</span>
              </div>
              <div *ngIf="getZoneModifiable(feature,'pii') && feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                  <mat-icon  [svgIcon]="getZoneValue(feature,'pii') ? 'done' :'close'" [ngClass]="getZoneValue(feature,'pii') ? 'selected' :'not-selected'"></mat-icon>
              </div>
              <div *ngIf="!getZoneModifiable(feature,'pii') || !feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                  <span>-</span>
              </div>
              <div *ngIf="getZoneModifiable(feature,'prod') && feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                <mat-icon [svgIcon]="getZoneValue(feature,'prod') ? 'done' : 'close'" [ngClass]="getZoneValue(feature,'prod') ? 'selected' :'not-selected'"></mat-icon>
              </div>
              <div *ngIf="!getZoneModifiable(feature,'prod') || !feature.modifiable" class="flex flex-col overview-values fw-700 ml-12 value-field">
                <span>-</span>
              </div>
            </div>
            <mat-divider *ngIf="!last" class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="{{'ADD_TENANT.SETTINGS' | transloco }}">
        <div class="flex flex-row">
        <div class="flex flex-col min-w-[50%]">
          <div class="metrics pt-8 pb-8">
            <div class="mb-2">{{ 'TENANT_LIST.ADD_EMAIL_ADDRESS' | transloco | titlecase }}</div>
            <div class="overview-values fw-700" *ngIf="tenantData?.notificationEmails?.length === 0">
              --
            </div>
            <div *ngIf="tenantData?.notificationEmails?.length > 0" class="max-w-2xl w-fit flex flex-wrap gap-1 items-center pt-8">
              <ng-container *ngFor="let email of tenantData?.notificationEmails; let last = last">
                <span class="overview-values fw-700">
                  {{ email ? email : '--' }}<span *ngIf="!last">,</span>
                </span>
              </ng-container>
            </div>
          </div> 
        </div>
        </div>
      </mat-tab>
    </mat-tab-group>
</div>
